import React, { Suspense, lazy } from 'react';
import {
  BrowserRouter as Router,
  Route, Routes
} from 'react-router-dom';
import { createBrowserHistory } from "history";
import paths from '../helpers/paths';
import DashBoard from '../components/DashBoard/DashBoard';
import ContactPage from '../components/Contact/ContactPage';
import AboutPage from '../components/About/AboutPage';
import SearchPage from '../components/SearchPage/SearchPage';
import Login from '../components/Auth/Login';
import SignUp from '../components/Auth/SignUp';
import RecoverPassword from '../components/Auth/RecoverPassword';
// import AdminDashBoard from '../components/admin/AdminDashBoard';
import ShoppingCart from '../components/ShoppingCart/ShoppingCart';
import NoPageFound from '../components/NotFound/NoPageFound';
import Payment from '../components/Payment/Payment';
import LCFCollection from '../components/LCFCollection/LCFCollection';
import Admin from '../components/Admin/Admin';
import CustomerReview  from '../components/CustomerReview/CustomerReview';



//switch ensures only the first match is rendered
export const history = createBrowserHistory();
CustomerReview
const AppRouter = () => (
  <Router history={history}>
    <div>
      <Routes> 
        <Route path="/" element={<DashBoard />} exact={true} key="homepageone"/>
        <Route path="/home" element={<DashBoard />} exact={true} key="homepagetwo"/>
        <Route path="/dashboard" element={<DashBoard />} exact={true} key="homepagethree"/>
        <Route path={paths.search} element={<SearchPage />} exact={true} key="searchpage"/>
        <Route path={paths.signup} element={<SignUp />} exact={true} key="signup"/>
        <Route path={paths.login} element={<Login />} exact={true} key="Login"/>
        <Route path={paths.recoverpassword} element={<RecoverPassword />} exact={true} key="recoverpassword"/>
        <Route path={paths.contact} element={<ContactPage />} exact={true} key="ContactPage"/>
        <Route path={paths.about} element={<AboutPage />} exact={true} key="AboutPage"/>
        <Route path={paths.shoppingcart} element={<ShoppingCart />} exact={true} key="ShoppingCart"/>
        <Route path={paths.payment} element={<Payment />} exact={true} key="payment"/>
        <Route path={paths.customerreview} element={<CustomerReview />} exact={true} key="customerreview"/>
        <Route path={paths.lcfcollection} element={<LCFCollection />} exact={true} key="lcfcollection"/>
        <Route path={paths.admin} element={<Admin />} exact={true} key="admin"/>
        <Route path="*" element={<NoPageFound />} exact={true} key="NoPageFound"/>
      </Routes>
    </div>
  </Router>
);

export default AppRouter;
